import { useContext, useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import classes from '../../../styles/AllDevices.module.css';
import { LoaderContext } from "../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../constants";
import { EventsService } from "../../../services/EventsService";
import { momentTimeFormater } from "../../../utils/dateHelper";
import Typography from "../../../components/Typography/Typography";
import CustomTooltip from "../../../components/CustomToolTip/CustomTooltip";
import { UilInfoCircle, UilSync } from '@iconscout/react-unicons';

import myClasses from '../../SmartCharging/SmartCharging.module.css';

const OverviewEvents = ({ }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);

    useEffect(() => {
        getEvents();
    }, []);

    const getEvents = () => {
        EventsService.GetOverviewEvents(
            () => startLoader('getEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('getEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {
        const processedData = data?.data?.data?.map((item, index) => {
            return {
                's.no': index + 1,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                bidStatus: item.bidStatus || '--',
                currentSOC: item.currentSOC ?? '--',
                power: item.power ?? '--',
                marketType: (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4vw' }}>
                        {item.marketType || '--'}
                        {item.market?.length > 0 && (
                            <CustomTooltip content={item.market.join(', ')}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </CustomTooltip>
                        )}
                    </span>
                ),
                isNextSlotAvailable: item.isNextSlotAvailable ? 'Yes' : 'No',
                lastReported: item.lastReportedTime ? momentTimeFormater(item.lastReportedTime).format('YYYY-MM-DD HH:mm:ss') : 'Offline',
            };
        });
        setEvents(processedData);
    };

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={classes.Alert}>
                <div className={myClasses.wholeFilterWrapper}>
                    <div className={myClasses.HeadingContainer}>
                        <Typography content={`Overview`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                    <CustomTooltip content={'Refresh'}>
                        <div className={classes.Action} onClick={() => getEvents()}>
                            <div>
                                <UilSync size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </div>
                        </div>
                    </CustomTooltip>
                </div>
                <Table
                    head={[
                        'Instance',
                        'Edge ID',
                        (<div>
                            <CustomTooltip content={'Status only denotes energy markets'}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.3vw' }}>
                                    <div>Bid Status</div>
                                    <UilInfoCircle size="1vw" />
                                </div>
                            </CustomTooltip>
                        </div>),
                        'Current SOC',
                        'Power',
                        'Market Type',
                        'Next Slot Available',
                        'Last Reported (CET)',
                    ]}
                    keys={[
                        'instanceName',
                        'edgeId',
                        'bidStatus',
                        'currentSOC',
                        'power',
                        'marketType',
                        'isNextSlotAvailable',
                        'lastReported',
                    ]}
                    data={events}
                />
            </div>
        </div>
    )
}

export default OverviewEvents;
